class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;
  upsellProducts = '';
  selectedVariantIds = {};

  connectedCallback() {
    fetch(`${routes.cart_url}.js`).then(data => data.json()).then(results => {
      this.initUpsellProducts(results)
    })
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    // fetch(`${routes.cart_url}.js`).then(data => data.json()).then(results => {
    //   this.initUpsellProducts(results)
    //   console.log("calleddddd")
    // })
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      // {
      //   id: 'main-cart-footer',
      //   section: document.getElementById('main-cart-footer').dataset.id,
      //   selector: '.js-contents',
      // },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        const cartTotal = document.querySelector('.cart_right .totals__total-value');
        const summaryBlock = document.querySelector('.cart_right');
        const purchaseEl = document.querySelector('.complete__your-purchase')

        if(cartTotal) {
          cartTotal.innerHTML = formatMoney(parsedState.total_price,window.moneyFormat);
        }

        if(parsedState.total_price == 0) {
          if(summaryBlock || purchaseEl) {
            summaryBlock.classList.add('hidden')
            purchaseEl.classList.add('hidden')
          }
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });

        // Call initUpsellProducts after updating the cart
        this.initUpsellProducts(parsedState);
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
  
  async initUpsellProducts(data) {
    const productIdsInCart = data.items.filter(item => item.handle !== "navidium-shipping-protection").map(item => item.product_id);

    if(data.items.length > 0){
        const swatchColorsArray = window.globalSettings.swatchColors.replace(/\n/g, '<br />').split('<br />');
        let variantMarkup = '';
        const allRecommendedProducts = [];
        document.querySelector('[data-spinner').classList.remove('hidden')
        document.querySelector('[data-spinner] .loading__spinner').classList.remove('hidden');
        if (document.querySelector('[data-spinner-main-cart]')) {
          document.querySelector('[data-spinner-main-cart').classList.remove('hidden')
          document.querySelector('[data-spinner-main-cart] .loading__spinner').classList.remove('hidden');
        }
        for (const productId of productIdsInCart) {
            const response = await fetch(`/recommendations/products.json?product_id=${productId}&limit=4&intent=related`);
            const newProductData = await response.json();
            allRecommendedProducts.push(...newProductData.products);
        }
    
        // LOGIC TO REMOVE DUPLICATE PRODUCTS
        const uniqueRecommendedProducts = allRecommendedProducts.filter((product, index, self) =>
            index === self.findIndex((p) => p.id === product.id)
        );
    
        // CHECK TO MAKE SURE THE PRODUCT IS NOT ALREADY IN THE CART
        const filteredRecommendedProducts = uniqueRecommendedProducts.filter(product => 
            !productIdsInCart.includes(product.id)
        );
        document.querySelector('[data-spinner] .loading__spinner').classList.add('hidden');
        if (document.querySelector('[data-spinner-main-cart]')) {
          document.querySelector('[data-spinner-main-cart] .loading__spinner').classList.add('hidden');
        }
        let recommendation_markup = '';
        const currency__symbol = document.querySelector('.cart__product-rec-list .list__inner').getAttribute('data-cur-symbol');
        for(let i=0; i < filteredRecommendedProducts.slice(-4).length; i++) {
          console.log(filteredRecommendedProducts[i]);
          let currentVariant = this.getSelectedOrFirstAvailableVariant(filteredRecommendedProducts[i])
          console.log(currentVariant, "currentVariant");

          if (filteredRecommendedProducts[i].variants.length > 1) {
            let ProductFormId = `cart-rec-id-${filteredRecommendedProducts[i].id}`;
            let colorCodes = '';
          
            variantMarkup = `
              <div class="cart-rec-variants">
                ${
                  filteredRecommendedProducts[i].options.map(op => {
                    const optionNames = window.globalSettings.optionName.split(",");
                    let useColor = false;
          
                    for (let j = 0; j < optionNames.length; j++) {
                      if (optionNames[j] === op.name) {
                        useColor = true;
                        break;
                      }
                    }
          
                    const variantsAvailableArr = filteredRecommendedProducts[i].variants.map(variant => variant.available);
                    const variantsOption1Arr = filteredRecommendedProducts[i].variants.map(variant => variant.option1);
                    const variantsOption2Arr = filteredRecommendedProducts[i].variants.map(variant => variant.option2);
                    const variantsOption3Arr = filteredRecommendedProducts[i].variants.map(variant => variant.option3);
          
                    const fieldsetHTML = op.values.map((value, opIndex) => {
                      let optionDisabled = true;
          
                      variantsOption1Arr.forEach((option1Name, index) => {
                        switch (op.position) {
                          case 1:
                            if (variantsOption1Arr[index] === value && variantsAvailableArr[index]) {
                              optionDisabled = false;
                            }
                            break;
                          case 2:
                            if (option1Name === currentVariant.option1 &&
                                variantsOption2Arr[index] === value && variantsAvailableArr[index]) {
                              optionDisabled = false;
                            }
                            break;
                          case 3:
                            if (option1Name === currentVariant.option1 &&
                                variantsOption2Arr[index] === currentVariant.option2 &&
                                variantsOption3Arr[index] === value && variantsAvailableArr[index]) {
                              optionDisabled = false;
                            }
                            break;
                        }
                      });
                      
                      ProductFormId = `cart-rec-id-${filteredRecommendedProducts[i].id}`;

                      const inputHTML = `
                        <input
                          type="radio"
                          id="cart-rec-id-${filteredRecommendedProducts[i].id}-${op.position}-${opIndex}-${value}"
                          name="cart-rec-id-${filteredRecommendedProducts[i].id}-${op.name}"
                          value="${value}"
                          form="cart-rec-id-${filteredRecommendedProducts[i].id}"
                          
                          ${currentVariant.options[op.position - 1] === value ? 'checked' : ''}
                          class="${optionDisabled ? 'disabled' : ''} cart-rec-variant-radio"
                        >`;
          
                      let colorNumber = 0;
                      for (const colorData of swatchColorsArray) {
                        const colorDataArr = colorData.split(":");
                        const ruleName = colorDataArr[0].trim();
          
                        if (value === ruleName) {
                          console.log(value, ruleName, "value, ruleName")
                          colorCodes = colorDataArr[1].trim().split("#").filter(Boolean);
                          colorNumber = colorCodes.length;
                          break;
                        }
                      }
          
                      let style = "";
          
                      switch (colorNumber) {
                        case 1:
                          if (colorCodes[0] === "") {
                            style = `background-color: ${value};`;
                          } else {
                            style = `background-color: #${colorCodes[0]};`;
                          }
                          break;
                        case 2:
                          style = `background: linear-gradient(135deg, #${colorCodes[0]} 50%, #${colorCodes[1]} 50%);`;
                          break;
                        case 3:
                          style = `background: linear-gradient(to right, #${colorCodes[0]} 33%, #${colorCodes[1]} 33%, #${colorCodes[2]} 66%);`;
                          break;
                        default:
                          break;
                      }
          
                      if (colorCodes[0] === "") {
                        style = `background-color: ${value};`;
                      }
                      
                      let labelHTML = ""; 

                      if (useColor) {
                        labelHTML = `
                        <label 
                          data-swatchType-color
                          style="${style}"
                          class="color-swatch round"
                          for="cart-rec-id-${filteredRecommendedProducts[i].id}-${op.position}-${opIndex}-${value}">
                          <span class="visually-hidden">Sold out or unavailable</span>
                        </label>`;
                      } else {
                        labelHTML = `
                        <label 
                          class="uppercase"
                          for="cart-rec-id-${filteredRecommendedProducts[i].id}-${op.position}-${opIndex}-${value}">
                          ${value}
                          <span class="visually-hidden">Sold out or unavailable</span>
                        </label>`;
                      }
          
                      return inputHTML + labelHTML;
                    }).join("");
          
                    return `
                      <fieldset class="js product-form__input product-form__input--pill mb-[33px] ${useColor ? 'input--pill__color' : ''}" ${op.name.includes('Print') ? 'data-print-fieldset' : ''}>
                        ${fieldsetHTML}
                      </fieldset>`;
                  }).join("")
                }
              </div>`;
        
          }          

            // recommendation_markup += `
            //   <div class="product-item-wrapper h-full">
            //     <div class="list_product flex-col swiper-slide w-full md:w-1/4 flex p-8 rounded-[1.6rem] bg-color-white h-full" data-cart-rec-product-card="${filteredRecommendedProducts[i].id}">
            //       <div class="image_block product-item-image-wrapper pt-[80%] w-4/5 ml-auto mr-auto relative overflow-hidden h-0 mb-6">
            //         <img width="100%" height="100%" class="absolute top-0 left-0 w-full h-full object-cover object-center" src="${filteredRecommendedProducts[i].images[0]}"/>
            //       </div>
            //       <div class="line__item-info">
            //         ${variantMarkup}
            //         <h4 class="product-item-title heading-4 text-color-black mb-5 leading-[1.44]">${filteredRecommendedProducts[i].title}</h4>
            //         <p class="price mb-4 inline-block product-item-price price-regular text-color-black font-semibold">${currency__symbol}${(filteredRecommendedProducts[i].price/100)}</p>
            //         <p class="line-through inline-block product-item-price price-small text-[12px] text-[#51534A] pl-3 font-medium compare_price ${(filteredRecommendedProducts[i].compare_at_price == null) ? "d-none":"d-inline-block"}">${currency__symbol}${filteredRecommendedProducts[i].compare_at_price/100}</p>
            //       </div>
            //       <div class="cta_block w-full mt-[12px]">
            //         <button type="button" class="btn btn-secondary !min-h-[30px] !max-h-[30px] button rounded-[4px] bg-[#1F1F1F]  w-full text-[12px] tracking-[0.4px]" ${(!currentVariant.available) ? "disabled":''} data-add-btn data-variant="${currentVariant.id}">
            //           <span>${(currentVariant.available) ? "Add to cart":'Sold Out'}</span>
            //           <div class="loading__spinner hidden">
            //             <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            //               <circle class="path" stroke="white" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
            //             </svg>
            //           </div>
            //         </button>
            //       </div>
            //     </div>
            //   </div>`

            recommendation_markup += `
              <div class="swiper-slide !h-auto w-3/4 mr-3">
                <div class="product-item-wrapper h-full" data-cart-rec-product-card="${filteredRecommendedProducts[i].id}">
                  <div class="product-item p-8 rounded-[1.6rem] bg-color-white h-full flex flex-col relative">
                    <span class="product-item-badge product-item-badge--new block top-7 left-6 text-color-white bg-[#37BE75] rounded-full">🔥 NEW</span>
                    <div class="product-item-image-wrapper pt-[80%] w-4/5 ml-auto mr-auto relative overflow-hidden h-0 mb-6 mt-16">
                      <img width="100%" height="100%" loading="lazy" class="motion-reduce absolute top-0 left-0 w-full h-full object-cover object-center" src="${filteredRecommendedProducts[i].images[0]}"/>
                    </div>
                    <div class="product-item-content flex-1 flex flex-col">
                      <p class="product-item-type caption uppercase text-[#EAAB00] mb-4">${filteredRecommendedProducts[i].type}</p>
                      <div class="product-item-swatches mb-4">
                        ${variantMarkup}
                      </div>
                      <h3 class="product-item-title heading-4 text-color-black mb-5 leading-[1.44]">${filteredRecommendedProducts[i].title}</h3>
                      <div class="product-item-price-wrapper flex items-center flex-wrap mb-8">
                        <span class="product-item-price price-regular text-color-black font-semibold">${currency__symbol}${(filteredRecommendedProducts[i].price/100)}</span>
                        <s class="product-item-price price-small text-[#51534A] pl-3 font-medium ${(filteredRecommendedProducts[i].compare_at_price == null) ? 'hidden':'!inline-block'}">${currency__symbol}${filteredRecommendedProducts[i].compare_at_price/100}</s>
                      </div>

                      <div class="product-item-btn-wrapper cta_block flex-1 flex flex-col justify-end">
                        <button type="button" class="btn btn-secondary min-h-[unset] max-h-[unset] button rounded-[4px] bg-[#1F1F1F]  w-full text-[12px] tracking-[0.4px]" ${(!currentVariant.available) ? 'disabled':''} data-add-btn data-variant="${currentVariant.id}">
                          <span>${(currentVariant.available) ? "Add to cart":'Sold Out'}</span>
                          <div class="loading__spinner hidden">
                            <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                              <circle class="path" stroke="currentColor" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                            </svg>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>`
        }

        document.querySelector('[data-spinner').classList.add('hidden')
        if (document.querySelector('[data-spinner-main-cart]')) {
          document.querySelector('[data-spinner-main-cart').classList.add('hidden')
        }
        // document.querySelector('.cart__product-rec-list .list__inner').innerHTML = recommendation_markup;
        if (document.querySelector('[data-list-main-cart]')) {
          document.querySelector('[data-list-main-cart].list__inner').innerHTML = recommendation_markup;
        } else if (!(window.location.href.includes('/cart'))) {
          document.querySelector('[data-list-drawer-cart]').innerHTML = recommendation_markup;
        }
        document.querySelectorAll('[data-cart-rec-product-card]').forEach(card => {
          // Add event listener for radio button change event
          console.log(card.closest('[data-list-main-cart]'), 'data-list-main-cart')
          card.querySelectorAll('input[type="radio"].cart-rec-variant-radio').forEach((input, inputIndex) => {
            if (card.closest('[data-list-main-cart]')) {
              input.id = input.id.replace('cart-rec-id-', 'main-cart-rec-id-')
              input.name = input.name.replace('cart-rec-id-', 'main-cart-rec-id-')
              // Replace the 'for' attribute of the corresponding label
              const label = card.querySelectorAll('label')[inputIndex];
              label.htmlFor = label.htmlFor.replace('cart-rec-id-', 'main-cart-rec-id-');
            }
            input.addEventListener('change', () => {
              const selectedOptions = this.getSelectedOptions(card.querySelectorAll('input[type="radio"].cart-rec-variant-radio'));
              filteredRecommendedProducts.forEach(p => {
                const pID = card.dataset.cartRecProductCard;
                if (pID == p.id) {
                  console.log(selectedOptions, 'selectedOptions')
                  const variant = this.findVariant(selectedOptions, p);
                  if (variant) {
                    console.log(variant, "variant")
                    card.querySelector('[data-add-btn]').dataset.variant = variant.id
                    if (!variant.available) {
                      card.querySelector('[data-add-btn]').disabled = true;
                      card.querySelector('[data-add-btn] span').innerHTML = `Sold Out`
                    } else {
                      card.querySelector('[data-add-btn]').disabled = false;
                      card.querySelector('[data-add-btn] span').innerHTML = `Add to cart`
                    }
                  }
                }
              })
            });
          });
        })
        const buttons = document.querySelectorAll('[data-add-btn]');
        buttons.forEach((el)=>{
            el.addEventListener('click',async (ev)=>{
                await this.addItem(data,ev.currentTarget.dataset.variant,ev);
            })
        })
        this.upsellProducts = filteredRecommendedProducts;
        this.upsellProducts.forEach(product => {
            if (product.variants.length > 0) {
                const availableVariant = product.variants.find(variant => variant.available);
                if (availableVariant) {
                this.selectedVariantIds[product.id] = availableVariant.id;
                } else {
                    console.error("No available variant for product:", product.id);
                }
            }
        });
    }
  }

  getSelectedOrFirstAvailableVariant(product) {
    // Check if a variant is selected
    const selectedVariant = product.variants.find(variant => variant.selected);
  
    // If there's a selected variant and it's available, return it
    if (selectedVariant && selectedVariant.available) {
      return selectedVariant;
    }
  
    // Otherwise, return the first available variant
    return product.variants.find(variant => variant.available);
  }

  // Function to get selected options
  getSelectedOptions(options) {
    // const options = document.querySelectorAll('.emc-product-variant-radios .variant-input-wrap');
    const selectedOptions = [];
    options.forEach(option => {
      if (option.checked) {
        selectedOptions.push(option.value);
      }
    });
    return selectedOptions;
  }

  // Function to find variant based on selected options
  findVariant(selectedOptions, product) {
    return product.variants.find(variant => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });
  }

  addItem = async (data,id,ev) => {  // make this function async
    ev.currentTarget.classList.add('loading');
    ev.currentTarget.querySelector('.loading__spinner').classList.remove('hidden');
    let formData = {
        items: [
            {
                id: Number(id),
                quantity: 1,
            },
        ],
    };
    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
      });
      const cartData = await response.json();
      console.log('cartData',cartData)    
      publish(PUB_SUB_EVENTS.cartUpdate, e => {
          "cart-items" !== e.source && this.onCartUpdate();
      });  
    } catch (error) {
      console.error("Error:", error);
    } finally {
      ev.currentTarget.classList.remove('loading');
      ev.currentTarget.querySelector('.loading__spinner').classList.add('hidden');
      $.getJSON('/cart.js', function(cart){ 
          document.querySelector('.cart-count-bubble').innerHTML = cart.item_count;
      });
    }
  };
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
